import { GOALS_ACTIONS } from "../actionTypes";

const goalsReducer = (state, action) => {
  switch (action.type) {
    case GOALS_ACTIONS.LOAD_ROOT_OBJECTIVES:
      return {
        ...state,
        objectives: action.payload.objectives || [],
        rootObjectives: action.payload.objectives || [],
        loading: false,
        error: null,
      };
    case GOALS_ACTIONS.LOAD_BRANCH_OBJECTIVES:
      // Merge new branch data into existing objectives
      // This will be enhanced based on tree structure needs
      return {
        ...state,
        objectives: [...state.objectives, ...(action.payload.objectives || [])],
        loading: false,
        error: null,
      };
    case GOALS_ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case GOALS_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default goalsReducer;
